
import React from "react";
import axios from "axios";
import {Base_Url} from './config'


export const LoginRequest = async (data) => {
    try {
        const response = await axios.post(`${Base_Url}/api/login`, data);
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};
